import {
    Element,
    HTMLReactParserOptions,
} from 'html-react-parser';
import { ReactNode } from 'react';
import WpPostNavigationLink from '@app/components/WpPostNavigation/WpPostNavigationLink';

const headingLevels = ['h2', 'h3'];

/**
 * Опции парсера для WpPostNavigation
 */
export const options: HTMLReactParserOptions = {
    replace: (domNode: Element, id: number) => {
        const {
            name,
            children,
        } = domNode;

        // Для формирования содержания, нам необходимы только заголовки и их содержимое.
        if (!headingLevels.includes(name)) {
            // eslint-disable-next-line react/jsx-no-useless-fragment
            return <></>;
        }

        const {
            name: childrenName,
        } = children[0] as Element;

        // В заголовке можно отобразить любое содержимое, кроме изображений, поэтому делаем дополнительную проверку на них.
        if (childrenName === 'img') {
            // eslint-disable-next-line react/jsx-no-useless-fragment
            return <></>;
        }

        return (
            <WpPostNavigationLink
                id={id}
                name={name}
            >
                {children as ReactNode}
            </WpPostNavigationLink>
        );
    },
};

/**
 * Функция для проверки контент навигации поста, на пустоту
 *
 * @param parsedContent - содержание навигационного меню
 */
export const checkContentEmpty = (parsedContent: string | JSX.Element | JSX.Element[]) => {
    const isArray = Array.isArray(parsedContent);

    return !isArray || !parsedContent.find(value => value.props?.id);
};